const doc = [({"ja":({"adminConstantHotelQuestionAnswerType":({"text":"自由入力(1行)", "textarea":"自由入力(複数行)", "selectTag":"選択肢(プルダウン)", "radio":"選択肢(ラジオボタン)"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;